import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { NoData } from "src/shared/components/tables/no-data";
import { TableLoadingSkeleton } from "src/shared/components/tables/table-loading-skeleton";
import { SalaryEventDeduction } from "src/types/salary";
import { formatNumber } from "src/utils";

const headCellSx = {
  fontSize: "12px",
  fontWeight: 500,
  lineHeight: "18px",
  color: "#475467",
  bgcolor: "#F9FAFB",
  whiteSpace: "nowrap",
} as const;

const SalaryEventsTable = ({
  list,
  isLoading,
}: {
  list: SalaryEventDeduction[];
  isLoading: boolean;
}) => {
  const { t } = useTranslation("salary");
  const { t: generalT } = useTranslation("general");

  const tableHeadText = [
    generalT("reference"),
    generalT("date"),
    t("eventAmount"),
    t("deductedAmount"),
    generalT("createdAt"),
  ];

  return (
    <Box>
      <Typography mb={1}>{t("eventDeductions")}</Typography>
      <TableContainer component={Paper} variant="outlined">
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              {tableHeadText.map((item) => (
                <TableCell key={item} align="center" sx={headCellSx}>
                  {item}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {isLoading ? (
            <TableLoadingSkeleton rowsLength={4} cellsLength={5} />
          ) : (
            <TableBody>
              {list.map((row) => (
                <TableRow
                  key={row.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="center">
                    {row.purchase_event_reference}
                  </TableCell>
                  <TableCell align="center">
                    {row.purchase_event_date ?? "—"}
                  </TableCell>
                  <TableCell align="center">
                    {formatNumber(row.purchase_event_amount)}
                  </TableCell>
                  <TableCell align="center">
                    {formatNumber(row.amount)}
                  </TableCell>
                  <TableCell align="center" dir="ltr">
                    {row.created_at ?? "—"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          )}
        </Table>
        {!isLoading && list.length === 0 && <NoData />}
      </TableContainer>
    </Box>
  );
};

export default SalaryEventsTable;
